import { getBaseURL } from '../../../../../GlobalComponents/URLs'
import { sendLog } from '../../../Logging/SendLog'

const updateServiceType = (recordId) => {
    let url = `${getBaseURL()}webapi/form/updateServiceType`
    // use fetch to get form values
    fetch(url, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
            recordId: recordId,
            serviceType: 'R',
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

// returns a row if it exists in dataToCheck
const getExistingData = (dataToCheck, FormSectionFieldId, RecordId) => {
    return dataToCheck.find(
        (x) => x.FormSectionFieldId === FormSectionFieldId && x.RecordId === RecordId
    )
}

// getting selected attachment multivalues from dataToCheck
const getExistingAttachmentMultiValue = (
    dataToCheck,
    FormSectionFieldId,
    RecordId,
    SystemFilename,
    StringFieldValue
) => {
    return dataToCheck.find(
        (x) =>
            x.RecordId === RecordId &&
            x.FormSectionFieldId === FormSectionFieldId &&
            x.SystemFilename === SystemFilename &&
            x.StringFieldValue === StringFieldValue
    )
}

const diff = (d1, d2) => {
    let keys = [
        'FormSectionFieldAttachment',
        'FormSectionFieldAttachmentMultiValue',
        'FormSectionFieldMultiValue',
        // 'FormSectionFieldOption',
        'FormSectionFieldValueView',
    ]
    let diffDict = {}
    let fsfidKey = 'FormSectionFieldId'
    keys.forEach((key) => {
        diffDict[key] = []
        if (!d1[key]) return

        d1[key].forEach((d1Row) => {
            let d2Row = d2[key].find((d2Row_) => d1Row[fsfidKey] === d2Row_[fsfidKey])
            //if row isnt in new default data we don't care about in old deletes
            if (!d2Row) return
            let hasDiff = false
            let index
            Object.keys(d1Row).forEach((dKey) => {
                if (d1Row[dKey] !== d2Row[dKey]) {
                    hasDiff = true
                    diffDict[key] = diffDict[key] || []
                    index = index === undefined ? diffDict[key].length : index
                    diffDict[key][index] = diffDict[key][index] || {
                        FormSectionFieldId: d1Row[fsfidKey],
                    }
                    diffDict[key][index][dKey] = d2Row[dKey]
                }
            })
        })
    })
    return diffDict
}

export const prepareData = async (
    saveData,
    setDisableSubmits,
    setFieldChanged,
    setRecordId,
    defaultDataRef,
    newFormAssetType,
    newFormServiceType,
    recordLockLevelRef,
    lockedLevels,
    recordId,
    formId,
    saving,
    defaultData,
    data,
    versionNumber,
    setSaving,
    setSavedTime,
    savingRef,
    setBaseData
) => {
    setDisableSubmits(true)

    let saveDefaultData = defaultDataRef.current

    let returnData = []
    let returnDeletedData = []
    var returnMultiValueData = []
    var returnDeletedMultiValueData = []
    let returnAttachmentData = []
    let returnDeletedAttachmentData = []
    var returnAttachmentMultiValueData = []
    var returnDeletedAttachmentMultiValueData = []
    let returnDS = {}
    let isVisible
    const newDataObject = JSON.parse(JSON.stringify(saveData))
    // let invalidFields = [];
    saveData.FormSectionFieldValueView.forEach((curRecord) => {
        const prevRecord = saveDefaultData.FormSectionFieldValueView.find(
            (x) =>
                x.FormSectionFieldId === curRecord.FormSectionFieldId &&
                x.RecordId === curRecord.RecordId
        )
        isVisible = true
        let curValue = ''
        let prevValue = ''
        let valueFieldName = ''
        try {
            valueFieldName = `${curRecord.DataType.trim()}FieldValue`
            curValue = curRecord[valueFieldName] === null ? '' : curRecord[valueFieldName]
            prevValue = prevRecord
                ? prevRecord[valueFieldName] === null
                    ? ''
                    : prevRecord[valueFieldName]
                : ''

            if (curRecord.DataType.trim().toUpperCase() === 'DATE') {
                // Only compare date strings for date field, not times
                if (curValue !== '') {
                    if (curValue.indexOf('T') > -1)
                        curValue = curValue.substring(0, curValue.indexOf('T'))
                }
                if (prevValue !== undefined && prevValue !== '') {
                    if (prevValue.indexOf('T') > -1)
                        prevValue = prevValue.substring(0, prevValue.indexOf('T'))
                }
            }
        } catch (ex) {
            console.log('Error ' + ex)
        }

        let alreadyRemoved = false
        if (!isVisible && prevRecord[valueFieldName]) {
            returnDeletedData.push({
                FormSectionFieldId: curRecord.FormSectionFieldId,
                RecordId: curRecord.RecordId,
                [valueFieldName]: prevRecord[valueFieldName],
                LockLevel: curRecord.LockLevel,
                RecordLockLevel: curRecord.RecordLockLevel,
            })
            alreadyRemoved = true
        }
        if (
            !isVisible &&
            ((prevRecord && prevRecord.ValidationType === 'Picture') ||
                (prevRecord && prevRecord.ValidationType === 'Multi-Select'))
        ) {
            // removeMultiChildren(data, curRecord.FormSectionFieldId)
            let removingMultiValues = saveData.FormSectionFieldMultiValue.filter(
                (x) => x.FormSectionFieldId === curRecord.FormSectionFieldId
            )
            removingMultiValues.forEach((x) => {
                if (!saveData.FormSectionFieldMultiValueDeleted)
                    saveData.FormSectionFieldMultiValueDeleted = []
                saveData.FormSectionFieldMultiValueDeleted.push(x)
                let valIdx = saveData.FormSectionFieldMultiValue.indexOf(x)
                saveData.FormSectionFieldMultiValue.splice(valIdx, 1)
            })
            // removeAttachmentChildren(data, curRecord.FormSectionFieldId)
            let removingAttachments = saveData.FormSectionFieldAttachment.filter(
                (x) => x.FormSectionFieldId === curRecord.FormSectionFieldId
            )
            removingAttachments.forEach((x) => {
                if (!saveData.FormSectionFieldAttachmentDeleted)
                    saveData.FormSectionFieldAttachmentDeleted = []
                saveData.FormSectionFieldAttachmentDeleted.push(x)
            })
            let removingAttachmentMultiValues =
                saveData.FormSectionFieldAttachmentMultiValue.filter(
                    (x) => x.FormSectionFieldId === curRecord.FormSectionFieldId
                )
            removingAttachmentMultiValues.forEach((x) => {
                if (!saveData.FormSectionFieldAttachmentMultiValueDeleted)
                    saveData.FormSectionFieldAttachmentMultiValueDeleted = []
                saveData.FormSectionFieldAttachmentMultiValueDeleted.push(x)
                let valIdx = saveData.FormSectionFieldAttachmentMultiValue.indexOf(x)
                saveData.FormSectionFieldAttachmentMultiValue.splice(valIdx, 1)
            })
        }
        if (
            (curValue !== prevValue ||
                ((curRecord && curRecord.LockLevel) ?? undefined) !==
                    ((prevRecord && prevRecord.LockLevel) ?? undefined)) &&
            !alreadyRemoved
        ) {
            if (curRecord[valueFieldName] === null || curRecord[valueFieldName] === '') {
                returnDeletedData.push({
                    FormSectionFieldId: curRecord.FormSectionFieldId,
                    RecordId: curRecord.RecordId,
                    [valueFieldName]: prevRecord ? prevRecord[valueFieldName] : '',
                    LockLevel: curRecord.LockLevel ? curRecord.LockLevel : 0,
                    RecordLockLevel: curRecord.RecordLockLevel,
                })
            } else {
                if (
                    curRecord.FieldNameQuery.toUpperCase() === 'REPAIRREQUIRED' &&
                    curRecord[valueFieldName] === true
                ) {
                    updateServiceType(curRecord.RecordId)
                }

                returnData.push({
                    FormSectionFieldId: curRecord.FormSectionFieldId,
                    RecordId: curRecord.RecordId,
                    [valueFieldName]:
                        curRecord.DataType.trim() === 'String'
                            ? curRecord[valueFieldName] && curRecord[valueFieldName].trim()
                            : curRecord[valueFieldName],
                    LockLevel: curRecord.LockLevel,
                    RecordLockLevel: curRecord.RecordLockLevel,
                })
            }
        }
    })

    returnMultiValueData = saveData.FormSectionFieldMultiValue.filter(
        (newRow) =>
            !saveDefaultData.FormSectionFieldMultiValue.find(
                (oldRow) => oldRow.StringFieldValue === newRow.StringFieldValue
            )
    )

    returnMultiValueData.forEach((curRecord) => {
        let bRecordAlreadyAdded = !!getExistingData(
            returnData,
            curRecord.FormSectionFieldId,
            curRecord.RecordId
        )
        if (!bRecordAlreadyAdded) {
            returnData.push({
                FormSectionFieldId: curRecord.FormSectionFieldId,
                RecordId: curRecord.RecordId,
                StringFieldValue: '',
            })
        }
    })

    returnDeletedMultiValueData = saveDefaultData.FormSectionFieldMultiValue.filter(
        (oldRow) =>
            !saveData.FormSectionFieldMultiValue.find(
                (newRow) => oldRow.StringFieldValue === newRow.StringFieldValue
            )
    )
    returnDeletedMultiValueData.forEach((curRecord) => {
        let bMVRecordsAllGone = !getExistingData(
            saveData.FormSectionFieldMultiValue,
            curRecord.FormSectionFieldId,
            curRecord.RecordId
        )
        let bRecordAlreadyDeleted = !!getExistingData(
            returnDeletedData,
            curRecord.FormSectionFieldId,
            curRecord.RecordId
        )

        if (bMVRecordsAllGone && !bRecordAlreadyDeleted) {
            returnDeletedData.push({
                FormSectionFieldId: curRecord.FormSectionFieldId,
                RecordId: curRecord.RecordId,
                StringFieldValue: '',
            })
        }
    })

    // add attachments to return data if they were not present in original data or order/caption has changed
    saveData.FormSectionFieldAttachment.forEach((curRecord) => {
        let prevRecord = saveDefaultData.FormSectionFieldAttachment.find(
            (x) =>
                x.FormSectionFieldId === curRecord.FormSectionFieldId &&
                x.RecordId === curRecord.RecordId &&
                x.SystemFilename === curRecord.SystemFilename
        )

        if (
            !prevRecord ||
            curRecord.OrderBy !== prevRecord.OrderBy ||
            curRecord.Caption !== prevRecord.Caption
        )
            returnAttachmentData.push(curRecord)
    })

    // add deleted attachments to return data if they WERE present in original data
    if (saveData.FormSectionFieldAttachmentDeleted) {
        saveData.FormSectionFieldAttachmentDeleted.forEach((curRecord) => {
            let prevRecord = saveDefaultData.FormSectionFieldAttachment.find(
                (x) =>
                    x.FormSectionFieldId === curRecord.FormSectionFieldId &&
                    x.RecordId === curRecord.RecordId &&
                    x.SystemFilename === curRecord.SystemFilename
            )

            if (prevRecord) returnDeletedAttachmentData.push(curRecord)
        })
    }

    // add attachment multi values to return data if they were not present in original data
    saveData.FormSectionFieldAttachmentMultiValue.forEach((curRecord, i) => {
        let prevRecord = saveDefaultData.FormSectionFieldAttachmentMultiValue.find(
            (x) =>
                x.FormSectionFieldId === curRecord.FormSectionFieldId &&
                x.RecordId == curRecord.RecordId &&
                x.SystemFilename === curRecord.SystemFilename &&
                x.StringFieldValue === curRecord.StringFieldValue
        )
        if (!prevRecord || curRecord.StringFieldValue !== prevRecord.StringFieldValue) {
            // reindexing since somewhere it's broken and makes dupes and they really just need to be unique when adding
            let newRecord = { ...curRecord }
            newRecord.ValueId = -(i + 1)
            returnAttachmentMultiValueData.push(newRecord)
        }
    })

    // add deleted attachment multi values to return data if they WERE present in original data
    if (saveData.FormSectionFieldAttachmentMultiValueDeleted) {
        saveData.FormSectionFieldAttachmentMultiValueDeleted.forEach((curRecord) => {
            let prevRecord = saveDefaultData.FormSectionFieldAttachmentMultiValue.find(
                (x) =>
                    x.FormSectionFieldId === curRecord.FormSectionFieldId &&
                    x.RecordId == curRecord.RecordId &&
                    x.SystemFilename === curRecord.SystemFilename &&
                    x.StringFieldValue === curRecord.StringFieldValue
            )

            let AMVRecordAddedBack = !!getExistingAttachmentMultiValue(
                saveData.FormSectionFieldAttachmentMultiValue,
                curRecord.FormSectionFieldId,
                curRecord.RecordId,
                curRecord.SystemFilename,
                curRecord.StringFieldValue
            )
            if (prevRecord && !AMVRecordAddedBack)
                returnDeletedAttachmentMultiValueData.push(curRecord)
        })
    }

    if (returnData.length > 0) returnDS.FormSectionFieldValueView = returnData
    if (returnDeletedData.length > 0) returnDS.FormSectionFieldValueViewDeleted = returnDeletedData
    if (returnMultiValueData.length > 0) returnDS.FormSectionFieldMultiValue = returnMultiValueData
    if (returnDeletedMultiValueData.length > 0)
        returnDS.FormSectionFieldMultiValueDeleted = returnDeletedMultiValueData
    if (returnAttachmentData.length > 0) returnDS.FormSectionFieldAttachment = returnAttachmentData
    if (returnDeletedAttachmentData.length > 0)
        returnDS.FormSectionFieldAttachmentDeleted = returnDeletedAttachmentData
    if (returnAttachmentMultiValueData.length > 0)
        returnDS.FormSectionFieldAttachmentMultiValue = returnAttachmentMultiValueData
    if (returnDeletedAttachmentMultiValueData.length > 0)
        returnDS.FormSectionFieldAttachmentMultiValueDeleted = returnDeletedAttachmentMultiValueData
    if (newFormAssetType !== '' && newFormAssetType > -1)
        returnDS.CustomerAssetTypeRecord = [
            {
                CustomerAssetTypeID: newFormAssetType,
                ServiceType: newFormServiceType.toUpperCase(),
            },
        ]

    // lock the form if lock on save -- happens in webapi since we dont have form object here
    returnDS.FormRecord = [
        {
            RecordLockLevel: recordLockLevelRef,
            FormId: saveData.FormSectionFieldValueView[0].FormId,
            LockedLevels: lockedLevels,
        },
    ]

    let tagUid = data.FormSectionFieldValueView?.find(
        (d) => d.FieldNameQuery === 'TagUID'
    )?.NumericFieldValue
    returnDS.OrderInfo = data.OrderInfo[0]
    returnDS.OrderInfo.SerialNumber = getSerialNumber(data)
    returnDS.OrderInfo.AWCAssemblyId = tagUid
    // between the way fsfvv is populated between forms and record mode easiest to just do this
    if (recordId === -1) {
        delete returnDS.FormSectionFieldValueViewDeleted
    }
    // save formId for use in fetch steps
    const myFormId = formId

    // save recordId for use in fetch steps
    const myRecordId = recordId

    let startFetch = new Date()
    // return
    // use fetch to POST form values to server for saving
    setBaseData(newDataObject)
    fetch(
        `${getBaseURL()}webapi/form/${
            myRecordId > 0 ? `record/${myRecordId}` : `form/${myFormId}`
        }`,
        {
            method: 'POST',
            body: JSON.stringify(returnDS),
            headers: {
                //'Authorization': `bearer ${'token'}`,
                'Content-Type': 'application/json',
            },
            // allows webapi to check for cookies
            credentials: 'include',
            //}
        }
    )
        .then(function (response) {
            if (response.ok) {
                setFieldChanged(false)
                //window.removeEventListener('beforeunload', changeWarning)
                return response.text().then((res) => {
                    return { ok: true, resp: res }
                })
            }
            return response.text().then((res) => {
                return { ok: false, resp: res }
            })
        })
        .then(function (body) {
            if (!body.ok) throw new Error(body.resp)

            let url = `/FormGeneric/form/${myFormId}`
            let newRecordId = myRecordId
            if (myRecordId > 0) {
                url = `/FormGeneric/record/${myRecordId}`
                if (window.location.pathname !== url) window.history.pushState('', '', url)
            } else {
                //turn form into record if we are staying on this page with new form
                newRecordId = parseInt(body.resp)
                window.history.pushState('', '', `/FormGeneric/record/${newRecordId}`)
                setRecordId(newRecordId)
            }

            //refreshDefaultData(newRecordId)
            setDisableSubmits(false)
            setSaving(false)

            savingRef.current = false
            const time = new Date().toLocaleString('en-US', {
                timeZone: 'America/Chicago',
            })
            setSavedTime(time)
            // if no more saves pending flush post save event queue
            //if (!waitingToSave) queueRef.current.flushEventQueue(newRecordId)
            return true
        })
        .catch(function (error) {
            setSaving(false)
            savingRef.current = false
            setDisableSubmits(false)
            let logEntry = `Reason: Post record ${recordId} startedAt ${startFetch} failed at ${new Date()} ${
                error.name
            } ${error.message} Stack: ${error.stack}`
            sendLog(logEntry)
            alert(`we encounter an error trying to save the data.  RecId=${recordId}`)
        })
}

export const checkInValid = (data, recordLockLevel) => {
    let newFormSectionFieldValueView = data.FormSectionFieldValueView.map((fdata) => {
        let isRequired = fdata.IsRequired && fdata.RequiredLockLevel <= recordLockLevel
        if (fdata.ValidationType.toUpperCase() === 'COMBOBOX' && isRequired) {
            return {
                ...fdata,
                invalid: fdata.StringFieldValue.trim().length === 0 ? true : false,
            }
        }
        return { ...fdata }
    })
    let someInvalid = newFormSectionFieldValueView.some((row) => row.invalid)
    return someInvalid
}
//TODO
// export const checkInValid = (data, recordLockLevel) => {
//     let newFormSectionFieldValueView = data.FormSectionFieldValueView.map((fdata) => {
//         // Check if the field is required based on IsRequired and RequiredLockLevel
//         let isRequired = fdata.IsRequired && fdata.RequiredLockLevel <= recordLockLevel

//         // Determine if the field is invalid based on the type and required status
//         let isInvalid =
//             isRequired &&
//             (fdata.StringFieldValue?.trim?.().length === 0 || fdata.StringFieldValue === null) &&
//             (fdata.NumericFieldValue === null || fdata.NumericFieldValue === undefined) &&
//             (fdata.DateFieldValue === null || fdata.DateFieldValue === undefined)

//         return {
//             ...fdata,
//             invalid: isInvalid,
//         }
//     })

//     // Check if any row is marked as invalid
//     let someInvalid = newFormSectionFieldValueView.some((row) => row.invalid)
//     return someInvalid
// }

export const getSerialNumber = (data) => {
    let serialNumber = data.FormSectionFieldValueView.find(
        (d) => d.FieldNameQuery === 'SerialNumber'
    )?.StringFieldValue
    let finalSerialNumber = data.FormSectionFieldValueView.find(
        (d) => d.FieldNameQuery === 'FinalSerialNumber'
    )?.StringFieldValue

    let result = ''
    if (
        serialNumber != undefined &&
        serialNumber != '' &&
        (finalSerialNumber === undefined || finalSerialNumber === '')
    ) {
        result = serialNumber
    } else if (serialNumber === finalSerialNumber) {
        result = serialNumber
    } else if (finalSerialNumber != serialNumber) {
        result = finalSerialNumber
    }

    return result
}
const refreshDefaultData = (recordId) => {
    const refreshTime = new Date()
    let baseResp = {}
    let dif = {}
    // use fetch to get form values
    fetch(`${getBaseURL()}webapi/form/record/${recordId}`, {
        credentials: 'include',
    })
        .then((response) => {
            if (response.ok) {
                return response.text()
            }

            if (response.status === 400) {
                // status 400 = bad request
                // webApi detected no cookies. alert then redirect.
                alert('Web Api detected no cookies. Please login.')
            }

            throw new Error('Network response was not ok.')
        })
        .then((responseText) => {
            // convert responseText (json text) into JSON object for easy consumption
            const response = JSON.parse(responseText)

            baseResp = JSON.parse(JSON.stringify(response))

            dif = diff(defaultDataRef.current, baseResp)
            setUpdateInfo({ info: dif, time: refreshTime })
            // make sure data was returned FormRecord Added for when records are auto generated (they're empty)
            if (response.FormSectionFieldValueView.length > 0 || response.FormRecord.length > 0) {
                if (response.FormRecord.length > 0 && response.FormRecord[0].LockLevel === -1)
                    setLocked(true)

                setData(baseResp)
                dataRef.current = JSON.parse(JSON.stringify(response))
                setDefaultData(JSON.parse(JSON.stringify(response)))
                defaultDataRef.current = JSON.parse(JSON.stringify(response))
            } else {
                // if no data returned for provided formId/recordId, let them know
                alert('Form not found!')
            }
            setSaving(false)
        })
        .catch((error) => {
            setSaving(false)
            let logEntry = `Reason: Refresh record ${recordId} startedAt ${refreshTime} failed at ${new Date()} ${
                error.name
            }
                ${error.message} Stack:${error.stack} 
                EventName: JS: Failed Refresh,Description:Refresh Version: ${versionNumber}`
            sendLog(logEntry)
        })
}
